import React from "react";
import Header from "../Header";
import MainComponent from "../MainComponent";
import Footer from "../Footer";
import FooterDown from "../FooterDown";
import Contact from "./Contact";

const ContactUsPage = () => {
  return (
    <div>
      <Header />
      <MainComponent type="contact" />
      <Contact />
      <Footer />
      <FooterDown />
    </div>
  );
};

export default ContactUsPage;
